// Keep items in alphabetical order!

const cookbookData = [
    {
        id: 'aria-markup',
        title: 'Add ARIA attributes to a canvas scene',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'To make a canvas scene as accessible as possible, it needs ARIA attributes',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['accessibility', 'user-experience', 'marketing'],
    }, 
    {
        id: 'google-analytics',
        title: 'Add Google Analytics to a canvas scene',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Add tracking code to a scene to help analyze user interactions with it',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['marketing'],
    }, 
    {
        id: 'add-using-cdn',
        title: 'Add Scrawl-canvas to a project',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Include Scrawl-canvas in a project, using the unpkg.com CDN',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['install'],
    }, 
    {
        id: 'add-using-parcel',
        title: 'Add Scrawl-canvas to a Parcel.js project',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Include Scrawl-canvas in a project that uses the Parcel.js bundler',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['install'],
    }, 
    {
        id: 'add-using-vite',
        title: 'Add Scrawl-canvas to a vanilla Vite project',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Include Scrawl-canvas in a project created using Vite',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['install'],
    }, 
    {
        id: 'add-to-a-react-project',
        title: 'Add Scrawl-canvas to a React project',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Include Scrawl-canvas in a React project, using NPM',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['install'],
    }, 
    {
        id: 'add-to-a-svelte-project',
        title: 'Add Scrawl-canvas to a Svelte project',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Include Scrawl-canvas in a Svelte project, using NPM',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['install'],
    }, 
    {
        id: 'handle-advert-sizes',
        title: 'Build a canvas scene that handles different sized containers',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Implement a canvas scene that can adapt to its environment - from "banner" to "skyscraper"',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['responsiveness', 'marketing'],
    }, 
    {
        id: 'progressive-enhancement-no-javascript',
        title: 'Handle cases where the user has disabled JavaScript',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Use progressive enhancement to handle environments where JavaScript has been disabled',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['accessibility', 'user-experience', 'marketing'],
    }, 
    {
        id: 'prefers-color-scheme',
        title: 'Implement dark and light theme versions of the canvas scene',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Detect a user\'s color scheme preference and adapt the canvas to match it',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['accessibility', 'user-experience', 'responsiveness', 'marketing'],
    }, 
    {
        id: 'prefers-reduced-motion',
        title: 'Listen for prefers-reduced-motion user requests',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Manage canvas animations when a user requests a reduced motion experience',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['accessibility', 'animation', 'user-experience'],
    }, 
    {
        id: 'responsive-images',
        title: 'Load and use responsive images',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Use HTML <img srcset="" sizes=""> to handle resolution switching',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['responsiveness', 'assets'],
    }, 
    {
        id: 'scene-graph',
        title: 'Add a graphic object to the scene graph',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Assign graphic entitys to canvas cell groups to render them in the scene',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['scene-graph'],
    }, 
    {
        id: 'display-cycle',
        title: 'Display a canvas scene',
        tabTitle: 'Scrawl-canvas Cookbook',
        description: 'Invoke a Display cycle to render a Scrawl-canvas scene',
        publishdate: "2024-04-27",
        validFrom: '8.10.0',
        tags: ['scene-graph', 'display-cycle'],
    }, 
    // {
    //     id: 'stop-start-animation',
    //     title: 'Start and stop a canvas animation',
    //     tabTitle: 'Scrawl-canvas Cookbook',
    //     description: '',
    //     publishdate: "2023-03-11",
    //     validFrom: '8.10.0',
    //     tags: ['accessibility', 'animation'],
    // }, 

];

export default cookbookData;
